"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockSapphireMapperLinearFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var MockSapphireMapperLinearFactory = /** @class */ (function (_super) {
    __extends(MockSapphireMapperLinearFactory, _super);
    function MockSapphireMapperLinearFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    MockSapphireMapperLinearFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    MockSapphireMapperLinearFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    MockSapphireMapperLinearFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    MockSapphireMapperLinearFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    MockSapphireMapperLinearFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return MockSapphireMapperLinearFactory;
}(contracts_1.ContractFactory));
exports.MockSapphireMapperLinearFactory = MockSapphireMapperLinearFactory;
var _abi = [
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "map",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_result",
                type: "uint256",
            },
        ],
        name: "setMapResult",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
var _bytecode = "0x608060405234801561001057600080fd5b5060ee8061001f6000396000f3fe6080604052348015600f57600080fd5b506004361060325760003560e01c80638a60d2e1146037578063cfc480c414605f575b600080fd5b604d60423660046088565b600054949350505050565b60405190815260200160405180910390f35b606f606a3660046071565b600055565b005b6000602082840312156081578081fd5b5035919050565b60008060008060808587031215609c578283fd5b505082359460208401359450604084013593606001359250905056fea26469706673582212202a377f1dcff5cf78b42880bdab7f837f81d08ca8a636837491581bc486f849c864736f6c63430008040033";
